import { createAction } from '@reduxjs/toolkit';

export const SetGameHover = createAction<string>('main/setGameHover');
